import Immutable from 'immutable';

const AttendanceHistoryItemsRecord = Immutable.Record({
  action: undefined,
  studentName: undefined,
  sessionDuration: undefined,
  previousStatus: undefined,
  currentStatus: undefined,
  editedByName: undefined,
  actionTime: undefined,
});

export class AttendanceHistoryItems extends AttendanceHistoryItemsRecord { }

const AttendanceHistoryTableRecord = Immutable.Record({
  studentAttendanceHistories: undefined,
  totalPages: undefined,
  pageNumber: undefined,
  totalRecords: undefined,
});

export class AttendanceHistoryTable extends AttendanceHistoryTableRecord {}



// WEBPACK FOOTER //
// ./data/AttendanceHistory/model/model.js